import { Pipe, PipeTransform } from '@angular/core';
import { RelatedProperties } from '@models/api-search.models';

@Pipe({
    name: 'hasRelatedProperties',
    standalone: true
})
export class HasRelatedPropertiesPipe implements PipeTransform {
    /**
     * Check if the related properties object has any properties inside of it
     * @param value - the related properties object
     * @param numOfRelatedProperties - the number of related properties to check for (default is 0), this is temporary for now we need it because of KOP-2527
     * @param shouldIncludePrimaryColor - check if needs to include the primary color in the count of related properties
     * @returns true if the related properties object has any properties inside of it, false otherwise
     */
    transform(
        value?: RelatedProperties,
        numOfRelatedProperties: number = 0,
        shouldIncludePrimaryColor: boolean = true
    ): boolean {
        const keys = Object.keys(value || {});

        if (numOfRelatedProperties === 0) {
            return keys.length > 0;
        }

        if (shouldIncludePrimaryColor) {
            return keys.some(key => key === 'primaryColor') && keys.length <= numOfRelatedProperties;
        }

        return keys.length <= numOfRelatedProperties;
    }
}
